import { useMemo } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { ComplaintFilters } from '../types';

const defaults: ComplaintFilters = {
  limit: 10,
  page: 0,
  orderBy: 'createdAt',
  order: 'desc',
  'createdAt.min': undefined,
  'createdAt.max': undefined,
  userId: undefined,
  clientId: undefined,
};

const numberFields: (keyof ComplaintFilters)[] = ['limit', 'page', 'userId', 'clientId'];

export function useComplaintFilters(initialFilters: Partial<ComplaintFilters> = {}) {
  const mergedDefaults = useMemo(
    () => ({ ...defaults, ...initialFilters }),
    [initialFilters]
  );

  return useUrlFilters<ComplaintFilters>({ defaults: mergedDefaults, numberFields });
}
